const LANGUAGES = {
	PL: {
		name: 'Polski',
		flag: 'pl',
	},
	EN: {
		name: 'English',
		flag: 'gb',
	},
	DE: {
		name: 'Deutsch',
		flag: 'de',
	},
	FR: {
		name: 'Français',
		flag: 'fr',
	},
	CZ: {
		name: 'Čeština',
		flag: 'cz',
	},
	SK: {
		name: 'Slovenčina',
		flag: 'sk',
	},
	UK: {
		name: 'Українська',
		flag: 'ua',
	},
	RU: {
		name: 'Русский',
		flag: 'ru',
	},
} as const;

export default LANGUAGES;
